import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { trackEvent } from 'src/analytics';
import { AppType, getCurrentScrren } from 'src/helpers/rest';
import { EVENTS } from 'src/analytics/events';
import { SUBSCRIPTION_CONST } from 'src/common/constants';

import HistorySelectedIcon from 'src/assets/images/mobile_history_selected.svg';
import HistoryIcon from 'src/assets/images/mobile_history.svg';
import ProfileSelectedIcon from 'src/assets/images/mobile_profile_selected.svg';
import ProfileIcon from 'src/assets/images/mobile_profile.svg';
import ChatSelectedIcon from 'src/assets/images/mobile_chat_selected.svg';
import ChatIcon from 'src/assets/images/mobile_chat.svg';
import UploadIcon from 'src/assets/images/mobile_upload.svg';
import UploadSelectedIcon from 'src/assets/images/mobile_upload_selected.svg';

import styles from './index.module.scss';
import { useDispatch } from 'react-redux';
import { setTextQuery } from 'src/redux/slices/open_ai';
import { useAppSelector } from 'src/redux/store';

const MobileNavigation: React.FunctionComponent = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const { version } = useAppSelector(state => state.socket);

    const app = searchParams.get('app') || localStorage.getItem('app');

    const appType: AppType =
        app === 'zymedelite' ? 'zymedelite' :
            app === 'ask_tatva' ? 'ask_tatva' :
                app === 'medeco' ? 'medeco' :
                    'tatva_ai';

    const onPressNavIcon = (navigateTo: string, tap_on: string) => {
        if (['/pdf-chat', '/'].includes(navigateTo) && navigateTo !== location.pathname) {
            dispatch(setTextQuery(''));
        }
        const currentScreen = getCurrentScrren(location.pathname);
        trackEvent(EVENTS.TAP_ON_BOTTOM_NAV, {
            tap_on: tap_on,
            screen_name: currentScreen,
            utm: true,
            search: window.location.search
        });
        navigate(navigateTo);
    };

    return (
        <div className={styles.mobile_nav_wrapper}>
            <div className={styles.nav_options}>
                <img src={['/', '/v1'].includes(location.pathname) ? ChatSelectedIcon : ChatIcon} className={styles.nav_option} onClick={() => onPressNavIcon(version === 'v1' ? '/v1' : '/', 'Ask')} alt='chat' />
                <img src={location.pathname === '/history' ? HistorySelectedIcon : HistoryIcon} className={styles.nav_option} onClick={() => onPressNavIcon('/history', 'History')} alt='history' />
                {appType === 'tatva_ai' && (
                    <>
                        <img src={location.pathname === '/pdf-chat' ? UploadSelectedIcon : UploadIcon} className={styles.nav_option} onClick={() => onPressNavIcon('/pdf-chat', 'Chat PDF')} alt='profile' />
                        <img src={location.pathname === '/profile' ? ProfileSelectedIcon : ProfileIcon} className={styles.nav_option} onClick={() => onPressNavIcon('/profile', 'Profile')} alt='profile' />
                    </>
                )}
            </div>
        </div>
    );
}

export default MobileNavigation;